import { SET_GUEST, RESET } from 'action-creators/travelArrangerGuest';
import { Guest } from 'services/userGuestService';

export interface TravelArrangerGuestState {
  guest: Guest;
}

const initialState: TravelArrangerGuestState = {
  guest: {
    name: '',
    lastName: '',
    phoneNumber: '',
    country: '',
    birthDate: '',
    email: '',
    gender: 'Male',
    documentNumber: '',
    passportNumber: '',
    userGroupId: '',
  },
};

const reducer = (state = initialState, action): TravelArrangerGuestState => {
  switch (action.type) {
    case SET_GUEST: {
      return {
        guest: action.payload,
      };
    }
    case RESET: {
      return initialState;
    }

    default:
      return state;
  }
};

export default reducer;
